(function () {
  'use strict';

  angular.module('app').component('featureDetail', featureDetail());

  function featureDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        additionalLanguages: '<',
        featureCategories: '<',
      },
      controller: FeatureDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/features/feature-detail/feature-detail.component.html',
    };
  }

  FeatureDetailCtrl.$inject = ['CONFIGURATIONS', 'UtilService', 'FeatureService'];

  function FeatureDetailCtrl(config, UtilService, FeatureService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = [
      'name',
      'description',
      'type',
      'visible_as_addon',
      'feature_category_id',
    ];

    vm.featureTypeOptions = config.FEATURE_TYPE_OPTIONS;

    // Methods
    vm.editFeature = editFeature;
    vm.openTranslations = openTranslations;
    vm.saveFeature = saveFeature;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.viewMode = true;

      if (mode === 'edit') {
        editFeature();
      }

      vm.saveButtonLabel = 'SAVE_CHANGES';

      vm.originalItem = angular.copy(item); // store server data
    }

    function editFeature() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function openTranslations() {
      FeatureService.openFeatureTranslations(vm.item, vm.additionalLanguages);
    }

    // Create/Update
    function saveFeature(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        FeatureService.saveFeature(vm.item).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            if (!vm.editMode) {
              // create
              vm.item = response; // reload item
            }

            setItemOptions(response, vm.mode);

            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = false;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
